(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/widget-area-fullscreen/assets/javascripts/widget-area-fullscreen.js') >= 0) return;  svs.modules.push('/components/onboarding/widget-area-fullscreen/assets/javascripts/widget-area-fullscreen.js');
"use strict";


const _svs$ui = svs.ui,
  ReactIconButton = _svs$ui.ReactIconButton,
  ReactIcon = _svs$ui.ReactIcon;
const WidgetArea = svs.components.tb_ui_react.widget_area.WidgetArea;
const ImageProvider = svs.components.onboarding.imageHelpers.ImageProvider;
const Brand = svs.ui.ReactBrand;
const WidgetAreaFullscreen = _ref => {
  let onCloseFullscreen = _ref.onCloseFullscreen,
    widgetAreaName = _ref.widgetAreaName,
    _ref$branding = _ref.branding,
    branding = _ref$branding === void 0 ? '' : _ref$branding;
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const isHeaderVisible = Boolean(branding);
  const onClosetrackAndCloseFullscreen = e => {
    svs.components.analytics.trackEvent({
      category: 'FTU',
      action: 'close_guide',
      opt_label: branding
    });
    onCloseFullscreen(e);
  };
  return React.createElement(ImageProvider, null, React.createElement("div", {
    className: "pg_fullscreen_onboarding onboarding-widget-area-fullscreen ".concat(branding, " ").concat(isLoggedIn ? 'logged-in' : '')
  }, React.createElement("div", {
    className: "pg_fullscreen_onboarding__content"
  }, React.createElement("div", {
    className: "pg_fullscreen_onboarding__content__header onboarding-widget-area-fullscreen-header"
  }, isHeaderVisible && React.createElement("div", {
    className: "pg_fullscreen_onboarding__content__header__title onboarding-widget-area-fullscreen-header-title"
  }, React.createElement(Brand, {
    alt: "".concat(branding, " logo"),
    brand: branding,
    className: "pg_fullscreen_onboarding__content__img onboarding-widget-area-fullscreen-header-title-img",
    emblem: true,
    size: 150
  })), React.createElement("div", {
    className: "pg_fullscreen_onboarding__content__close onboarding-widget-area-fullscreen-close"
  }, React.createElement(ReactIconButton, {
    onClick: onClosetrackAndCloseFullscreen
  }, React.createElement(ReactIcon, {
    color: "icon",
    icon: "close",
    size: 200
  })))), React.createElement(WidgetArea, {
    areaName: widgetAreaName,
    className: "onboarding-widget-area-fullscreen-area",
    widgetArea: widgetAreaName
  }))));
};
setGlobal('svs.components.onboarding.widgetAreaFullscreen.WidgetAreaFullscreen', WidgetAreaFullscreen);

 })(window);